var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE2DiningRoom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 3.63L3 25.89V69h70V25.9L38 3.63zM69 65H7V28.08L38 8l31 20.08V65zm-16-6.45V29.07a2.998 2.998 0 012.965-3.035A3 3 0 0159 29v16h-3v13.55A1.48 1.48 0 0154.55 60 1.56 1.56 0 0153 58.55zM37 37h3V26h3v11h3V26h3v11a7.51 7.51 0 01-6 7.35V59a1.5 1.5 0 11-3 0V44.35A7.51 7.51 0 0134 37V26h3v11zm-5 6.5a16.88 16.88 0 01-14.67 16.71v-4a12.86 12.86 0 000-25.34v-4A16.88 16.88 0 0132 43.5z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/E2_Dining_room.0aeb977f.svg";
export { SvgE2DiningRoom as ReactComponent };